import { render, staticRenderFns } from "./CatalogoCategoriasArchivos.vue?vue&type=template&id=8f7a08d6"
import script from "./CatalogoCategoriasArchivos.vue?vue&type=script&lang=js"
export * from "./CatalogoCategoriasArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports